export default __webpack_public_path__ + "static/banner-commute-etiquette-5ec7da9f2b55cf88e40f7d46bebb3f6c.jpg";